"use client";
import { Link } from "@areahub/ui";
import {
  Box,
  chakra,
  Heading,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { PageBlockDatasetTeaser } from "lib/gcms";
import { fmtThemeColor } from "utils";

// Pull articles from ghost to insert into homepage dataset teaser.
// Doesn't work since ghost/gcms key/slugs are different for categories + not all articles have an og_name
// It's simply not worth the time/effort to make this way work.
/*
const categoryMap: { [key: string]: any[] } = {};
(await getAllTags()).filter((x: GhostTag) => x.visibility === "public").forEach((x: GhostTag) => categoryMap[x.slug] = []);
(await getAllPosts()).forEach((x: GhostPostOrPage) => !!x.primary_tag?.slug && categoryMap[x.primary_tag.slug].push({ key: x.slug, displayName: x.og_title }));
page?.blocks?.filter((x) => x.__typename == "DatasetTeaser").forEach((x) => x.categories.forEach((x) => { x.subcategories = categoryMap[x.key]; console.log(x.key + " " + categoryMap[x.key]) }))
*/
// Out of desperation, hardcode in the articles here. Not all articles have an og_name and displaying article title doesn't make sense.
const articles: { [key: string]: any[] } = {
  infrastructure: ["Cell Towers", "High Voltage Power Lines"],
  natural: [
    "Hurricanes",
    "Wildfires",
    "Tornadoes",
    "Floods",
    "Severe Winter Weather",
    "Earthquakes",
    "Radon",
  ],
  industrial: [
    "Gas Pipelines",
    "Brownfields",
    "Superfunds",
    "Oil, Gas & Fracking Wells",
    "Nuclear Reactors",
  ],
  pollution: ["Air Quality", "Water Quality"],
};
Object.keys(articles).forEach(
  (x) => (articles[x] = articles[x].map((y) => ({ displayName: y }))),
);

const DatasetTeaser = ({
  title,
  subtitle,
  bg,
  color,
  categories,
}: PageBlockDatasetTeaser) => {
  // Replace categories with the hardcoded ones
  categories.forEach((x) => (x.subcategories = articles[x.key]));

  return (
    <Box as="section" bg={bg} color={color} py="12">
      <VStack
        textAlign="center"
        maxW={{ base: "xl", md: "7xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
        spacing="5"
      >
        <Heading
          letterSpacing="tight"
          fontWeight="extrabold"
          lineHeight="normal"
        >
          {title}
        </Heading>
        <Box as="div" fontSize="lg" pb="6" textAlign="center">
          <chakra.h3 apply="styles.mdx.h3" mt="0">
            {subtitle}
          </chakra.h3>
        </Box>
        <SimpleGrid columns={{ lg: 4, md: 2, base: 1 }} spacing="10">
          {Object.values(categories).map((cat: any, idx) => (
            <DatasetCategory key={idx} {...cat} />
          ))}
        </SimpleGrid>
      </VStack>
    </Box>
  );
};

const DatasetCategory = (category: any) => (
  <Link
    href={`/individuals/knowledge-center/category/${category.knowledgeBaseSlug}`}
    _hover={{
      transform: "scale(1.05)",
      textDecoration: "none",
    }}
  >
    <VStack
      bg={fmtThemeColor(category.statCardBg)}
      h="100%"
      shadow="lg"
      color="white"
      borderRadius="md"
      p="4"
    >
      <Heading as="div" fontSize="lg" mb="2">
        {category.displayName}
      </Heading>
      {Object.values(category.subcategories).map((subcat: any, idx) => {
        return <Text key={idx}>{subcat.displayName}</Text>;
      })}
    </VStack>
  </Link>
);

export default DatasetTeaser;
